import React from "react";

import styles from "./ListCard.module.scss";
import { OrderProps } from "../../types/order";
import { useAppDispatch } from "../../app/hooks";
import { updateIsImgModalOpen } from "../../features/settings/settingsSlice";
import { Link } from "react-router-dom";
import { route } from "../../static/route";
import OrderCloseForm from "./OrderCloseForm";

type Props = {
  order: OrderProps;
  index?: number | undefined;
};

const ListCard = ({ order, index }: Props) => {
  const dispatch = useAppDispatch();

  const handleShowImgModal = (src: string) => {
    dispatch(updateIsImgModalOpen(src));
  };

  return (
    <div className={styles.ListCard}>
      <h5 className="text-primary-1 text-lg font-semibold">
        કામ નું આઇડી : {order.id}
      </h5>

      <div className="flex gap-4 mt-5">
        <img
          className="w-[100px] h-[100px] bg-white"
          src={`${order.image}?order=${order.id}`}
          alt=""
          // onClick={() => handleShowImgModal(order.image)}
        />

        <div className="flex flex-col gap-3">
          <p className="text-primary-1 text-sm font-semibold">
            પાર્ટી નુ નામ : {order.party.firm_name}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            આઈટમ નુ નામ : {order.item.name}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            પ્રોસેસ નુ નામ : {order.process.name}
          </p>
          <p className="text-primary-1 text-sm font-semibold">
            નંગ ની સંખ્યા : {order.qty}
          </p>
        </div>
      </div>

      {index !== undefined && index >= 0 ? (
        <OrderCloseForm index={index} />
      ) : (
        <Link to={route.orderDetails + `/${order.id}`}>
          <button
            className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-1xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
            type="button"
          >
            કામ ની વિગતો જુઓ
          </button>
        </Link>
      )}
    </div>
  );
};
export default ListCard;
